export enum PadSide {
  Left = 0,
  Right = 1,
}
